export default "__VITE_ASSET__Cs9INJrQ__"